export const PRODUCT_LIST_ANCHOR = 'product-list-anchor';
export const PRODUCT_DESCRIPTION_ANCHOR = 'product-description-anchor';
export const TOP_PAGE_ANCHOR = 'top-page-anchor';
